
export const ESTADO_CHANGE_PAGINA = 'ESTADO_CHANGE_PAGINA';
export const ESTADO_CHANGE_CONEXION = 'ESTADO_CHANGE_CONEXION';
export const ESTADO_CHANGE_PERSONAL = 'ESTADO_CHANGE_PERSONAL';

export const PAGE_PRUEBA = 'PAGE_PRUEBA';
export const PAGE_PRINCIPAL = 'PAGE_PRINCIPAL';
export const PAGE_MARCAJE = 'PAGE_MARCAJE';
export const PAGE_MARCAJERESULTADO= 'PAGE_MARCAJERESULTADO';

export const PAGE_MARCAJESDIA= 'PAGE_MARCAJESDIA';

export const CONEXION_CONECTADO = 'CONEXION_CONECTADO';
export const CONEXION_DESCONECTADO = 'CONEXION_DESCONECTADO';

export const estadoChangePagina = (newPagina) => {
    return {
        type: ESTADO_CHANGE_PAGINA,
        newPagina: newPagina,
    }
}

export const estadoChangeConexion = (newConexion) => {
    return {
        type: ESTADO_CHANGE_CONEXION,
        newConexion: newConexion,
    }
}

export const estadoChangePersonal = (newPersonal) => {
    return {
        type: ESTADO_CHANGE_PERSONAL,
        newPersonal: newPersonal,
    }
}